<script setup lang="ts">
  // import { useAppModal } from '@/components/modal'
  import SectionMultiplierUnset from './section-multiplier-unset.vue'
  import SectionProductWithoutPrice from './section-product-without-price.vue'

  // import { ref } from 'vue'

  // const date1 = ref<Date | null>(null)
  // const date2 = ref<Date | null>(null)

  // const d = ref<Date | null>(null)

  // const { modal, close, open } = useAppModal()
</script>

<template>
  <div class="space-y-12">
    <div>
      <section-multiplier-unset />
    </div>

    <div>
      <section-product-without-price />
    </div>
  </div>
</template>

<style scoped>
@reference "@/assets/styles/main.css";

:deep() {
  h2 {
    @apply font-bold text-lg mb-4 mt-6;
  }
}
</style>
